import React from "react";
import {
  MDBCarousel,
  MDBCarouselInner,
  MDBCarouselItem,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBMask,
  MDBView,
} from "mdbreact";
import Project from "./Project.jsx";
import getFileData from "../../APICall/Api.jsx";
import Loading from "../../components/Loading/Loading.jsx";
import PublicationStyle from "./PublicationStyle.css";

class FeaturesPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      url: getFileData,
      mainNews: {},
      mainIndex: 0,
      nPages: 0,
      pages: [],
      img: {},
      animationClass: "",
    };
  }

  getItem(projectList, id) {
    return (
      <MDBCarouselItem itemId={id} key={id}>
        {projectList.map((prop, key) => (
          <Project
            key={key + prop.title}
            {...prop}
            focusNews={this.changeMainNews}
            isActiveClass={
              prop.title === this.state.mainNews.title
                ? "active-item heartBeat"
                : ""
            }
          />
        ))}
      </MDBCarouselItem>
    );
  }

  getProjects = () => {
    return (
      <MDBCarouselInner>
        {this.state.pages.map((prop, key) => this.getItem(prop, key + 1))}
      </MDBCarouselInner>
    );
  };

  changeMainNews = (news) => {
    var _img = new Image();
    //_img.src = news.foto;
    this.setState({
      mainNews: news,
      mainIndex: this.state.items.map((e) => e.title).indexOf(news.title),
      img: _img,
      animationClass: "active-item",
    });
    setTimeout(() => {
      this.setState({
        animationClass: "",
      });
    }, 1000);
  };

  formatText = (text) => {
    let newText = text.split("\n");

    return (
      <div>
        {newText.map((a, i) => (
          <p align="justify">{a}</p>
        ))}
      </div>
    );
  };

  callAPI = (lang) => {
    fetch(
      `${this.state.url.getFileData}/Publications${lang.capitalize()}.json`,
      {
        method: "get",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          var _resSortet = result.publications; //result.sort(function(a,b){return a.data - b.data}).reverse();
          var lastNews = _resSortet[this.state.mainIndex];

          var _img = new Image();
          //_img.src = lastNews.foto;

          let limit = 10;
          let _pages = _resSortet.chunk(limit);

          this.setState({
            mainNews: lastNews,
            items: _resSortet,
            img: _img,
            isLoaded: true,
            pages: _pages,
            nPages: _pages.length,
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error: error,
          });
        }
      );
  };

  componentDidMount() {
    this.callAPI(this.props.lang);
  }

  componentWillReceiveProps(newProps) {
    this.callAPI(newProps.lang);
  }

  render() {
    if (this.state.error) {
      return <div>Error: {this.state.error.message}</div>;
    } else if (!this.state.isLoaded) {
      return <Loading />;
    } else {
      return (
        //<Zoom top duration={2000}>
        <MDBCard
          className="my-5 px-5 mx-auto"
          style={{ fontWeight: 300, maxWidth: "90%" }}
        >
          <MDBCardBody style={{ paddingTop: 0 }}>
            <div>
              <h2
                className={`h1-responsive my-5 text-center font-weight-bold success-lighter-hover mb-3 ${
                  this.state.animationClass
                }`}
              >
                {this.props.title}
              </h2>
            </div>
            <MDBRow>
              <MDBCol md="12" lg="6">
                <div className="mb-4 --aspect-ratio: 16/9;">
                  <MDBView hover rounded className="z-depth-1-half mb-4">
                    <a>
                      <MDBMask overlay="white-slight" className="waves-light" />
                    </a>
                  </MDBView>
                  <div className="d-flex justify-content-between">
                    <p className="font-weight-bold success-lighter-hover mb-11 active-item">
                      {this.state.mainNews.title}
                    </p>
                  </div>
                  <div className="resp-container">
                    <iframe
                      title="publications"
                      className="resp-iframe"
                      frameBorder="0"
                      src={`${this.state.mainNews.path}#toolbar=0`}
                    />
                  </div>
                </div>
              </MDBCol>
              <MDBCol md="12" lg="6">
                <MDBCarousel
                  activeItem={1}
                  length={this.state.nPages}
                  slide={true}
                  showControls={true}
                  multiItem
                  testimonial
                >
                  {this.getProjects()}
                </MDBCarousel>
              </MDBCol>
            </MDBRow>
          </MDBCardBody>
        </MDBCard>
        //</Zoom >
      );
    }
  }
}

export default FeaturesPage;



// WEBPACK FOOTER //
// ./src/views/Publications/SectionProjects.jsx